﻿/**
* DevExpress Analytics (core\_actionProvider.js)
* Version:  21.2.7
* Build date: Apr 13, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ko = require("knockout");
var BaseActionsProvider = (function () {
    function BaseActionsProvider() {
    }
    BaseActionsProvider.prototype.initActions = function (actions) {
        this.actions = actions;
        this.actions.forEach(function (action) {
            if (!action.disabled)
                action.disabled = ko.observable(false);
        });
    };
    BaseActionsProvider.prototype.getActions = function (context) {
        if (this.condition(context)) {
            this.setDisabled && this.setDisabled(context);
            return this.actions;
        }
        return [];
    };
    BaseActionsProvider.prototype.condition = function (context) {
        return true;
    };
    return BaseActionsProvider;
}());
exports.BaseActionsProvider = BaseActionsProvider;
